<template>
  <div class="select-container">
    <h2>Filters:</h2>
    <el-select
      v-model="poFiltersSelected"
      multiple
      :multiple-limit="filterLimit"
      placeholder="Select a filter"
      @change="setFilter">
      <el-option-group
        v-for="group in poFilterOptions"
        :label="group.label"
        :key="group.label">
        <el-option
          v-for="item in group.options"
          :label="item.label"
          :value="item.value"
          :key="item.value">
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    selectedFilters: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      filterLimit: 4,
      poFilterOptions: [
        {
          label: 'Filter by status',
          options: [
            {
              value: 'created',
              label: 'Created',
            },
            {
              value: 'in-production',
              label: 'In Production',
            },
            {
              value: 'handed-over',
              label: 'Handed Over',
            },
            {
              value: 'shipped',
              label: 'Shipped/Delivered',
            },
          ],
        },
        {
          label: 'Filter by payment status',
          options: [
            {
              value: 'paid',
              label: 'Paid',
            },
            {
              value: 'pending',
              label: 'Pending',
            },
          ],
        },
      ],
      poFiltersSelected: [],
    };
  },
  computed: {
    getSearchFilterQuery() {
      return this.$store.getters.getFilterQuery;
    },
  },
  created() {
    this.poFiltersSelected = this.selectedFilters;
  },
  methods: {
    setFilter() {
      let filters = {};
      const types = {
        status: [],
        paymentStatus: [],
      };
      let statusFilter = ' ';
      let paymentStatusFilter = '';
      let moreThanOneFilterType = '';

      if (this.poFiltersSelected.length === 0) {
        types.status = [];
        types.paymentStatus = [];
        filters = {
          query: '',
          filterSelected: [],
        };
        this.$store.dispatch('setFilterSearchPO', filters);
        this.$store.dispatch('getSearchedPOData');
      } else {
        Object.keys(this.poFiltersSelected).map((key) => {
          switch (this.poFiltersSelected[key]) {
            case 'created':
            case 'in-production':
            case 'handed-over':
            case 'shipped':
              types.status.push(this.poFiltersSelected[key]);
              break;
            case 'paid':
            case 'pending':
              types.paymentStatus.push(this.poFiltersSelected[key]);
              break;
            default:
              break;
          }
          return types;
        });
        if (types.status.length > 1) {
          statusFilter += `status=${types.status.join('&status=')}`;
        } else if (typeof types.status[0] !== 'undefined') {
          statusFilter = `status=${types.status[0]}`;
        }

        if (types.paymentStatus.length > 1) {
          paymentStatusFilter =
            `paymentStatus=${types.paymentStatus.join('&paymentStatus=')}`;
        } else if (typeof types.paymentStatus[0] !== 'undefined') {
          paymentStatusFilter = `paymentStatus=${types.paymentStatus[0]}`;
        }

        if (statusFilter !== '' && paymentStatusFilter !== '') {
          moreThanOneFilterType = '&';
        }
        filters = {
          query: statusFilter + moreThanOneFilterType + paymentStatusFilter,
          filterSelected: this.poFiltersSelected,
        };
        this.$store.dispatch('setFilterSearchPO', filters);
        this.$store.dispatch('getSearchedPOData');
      }
    },
  },
};
</script>
<style lang="scss" >
.select-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
}
.el-select {
  flex: 2;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/partials/PoListFilter.vue